import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';

import RText from '../Text';

const getAlign = align => {
  switch (align) {
    case 'right':
      return 'flex-end';
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    default:
      return 'unset';
  }
};

const Text = props => <RText color="inherit" {...props} />;

const SplitText = ({
  left,
  right,
  seperator = '/',
  color,
  fontSize,
  fontWeight,
  align,
  containerStyle,
  ...restProps
}) => {
  const getTextComponent = node =>
    React.isValidElement(node) ? (
      node
    ) : (
      <Text fontSize={fontSize} fontWeight={fontWeight}>
        {node}
      </Text>
    );
  return (
    <Flex
      flexWrap="wrap"
      justifyContent={getAlign(align)}
      color={color}
      style={containerStyle}
      {...restProps}
    >
      {getTextComponent(left)}
      <Box px={1}>{getTextComponent(seperator)}</Box>
      {getTextComponent(right)}
    </Flex>
  );
};

SplitText.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  seperator: PropTypes.string,
  containerStyle: PropTypes.object,
  align: PropTypes.oneOf(['right', 'left', 'center']),
};

export default SplitText;
